// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"ebad961f","513":"7559835a","703":"622166c1","787":"ea947fea"}[chunkId] + ".chunk.js";
};